/**
 * Guest OCR entitlement counter.
 *
 * This is a STRICTLY NECESSARY functional counter, not analytics: it is the
 * state that decides whether the signup gate opens. It therefore lives in
 * localStorage independently of analytics consent, holds no PII, and stores a
 * single integer.
 *
 * Entitlement model:
 *   guest           -> 1 successful OCR, then signup required
 *   registered free -> 3/day (enforced by useDailyScans)
 *   pro             -> unlimited
 */
const KEY = "factscan:entitlement:free_ocr_used";

let memoryUsed = 0;

export function getFreeOcrUsed(): number {
  try {
    const raw = window.localStorage.getItem(KEY);
    const n = raw ? Number.parseInt(raw, 10) : 0;
    return Number.isFinite(n) && n >= 0 ? n : 0;
  } catch {
    return memoryUsed;
  }
}

export function recordFreeOcrUsed(): number {
  const next = getFreeOcrUsed() + 1;
  memoryUsed = next;
  try {
    window.localStorage.setItem(KEY, String(next));
  } catch {
    // in-memory fallback for the current page view
  }
  return next;
}

export function clearFreeOcrEntitlement(): void {
  memoryUsed = 0;
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}

/** True when a guest has already consumed their free OCR. */
export function guestHasUsedFreeOcr(): boolean {
  return getFreeOcrUsed() >= 1;
}
